import { MaestroAPI } from '@michelin/central-provider';
import GLOBAL_CONFIG from '../global-variables';

export const baseURL = GLOBAL_CONFIG.restAPIUrl;

export interface saveParams {
  stNumber: string,
  data: any
}

export function locationsList(btNumber: string): MaestroAPI {
  const endpoint = `locations/${btNumber}/list`;
  return { method: 'GET', endpoint, baseURL };
}

export function contactsList(stNumber: string): MaestroAPI {
  const endpoint = `contacts/${stNumber}/list`;
  return { method: 'GET', endpoint, baseURL };
}

export function contactsGet(stNumber: string, contact_id: string): MaestroAPI {
  const endpoint = `contacts/${stNumber}/${contact_id}`;
  return { method: 'GET', endpoint, baseURL };
}

export function getGooglePlacesInfo(place_id: string): MaestroAPI {
  const endpoint = `googlePlacesInfo?placeId=${place_id}`;
  return { method: 'GET', endpoint, baseURL };
}

export function getGooglePlacesPhotoUrls(): MaestroAPI {
  const endpoint = 'googlePlacesPhotoUrls';
  return { method: 'POST', endpoint, baseURL };
}

export function getBEVersion(): MaestroAPI {
  const endpoint = 'version';
  return { method: 'GET', endpoint, baseURL };
}

export const changeLogsEndpoint: string = `${baseURL}/locations/changelog`;

export function secondaryLocationsList(stNumber: string): MaestroAPI {
  const endpoint = `locations/${stNumber}/secondary-locations-list`;
  return { method: 'GET', endpoint, baseURL };
}

export function serviceAreasEligibleSTList(btNumber: string): MaestroAPI {
  const endpoint = `locations/${btNumber}/eligible-st-list`;
  return { method: 'GET', endpoint, baseURL };
}
